import React, { useState, useEffect, useRef } from "react";

import {
  HEADER_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  TERTIARY_COLOR,
  TEXT_COLOR,
} from "../constants/theme";
import { SlArrowRight } from "react-icons/sl";
import { FAQsArr } from "../constants/faqs";
import { glossaryData } from "../constants/glossary";
import { letters } from "../constants/letters";

const KnowledgeScreen = () => {
  const [knowledgeVal, setKnowledgeVal] = useState("Glossary");
  const [selectedGlossary, setSelectedGlossary] = useState("A");
  const [screenWidth, setScreenWidth] = useState(0);
  const scrollLettersRef = useRef();

  const handleScrollRight = () => {
    const scrollElement = scrollLettersRef.current;

    const scrollWidth = scrollElement.clientWidth;

    scrollElement.scrollLeft += scrollWidth - 100;
  };

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  return (
    <div
      className="position-relative"
      style={{
        minHeight: "100vh",
        zIndex: "20",
        padding: "2px 15px 10px 15px",
        // backgroundColor: '#fae5ff'
      }}
    >
      <div
        className="row w-100 mx-auto flex-column align-items-center justify-content-start"
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          padding: "0px 16px 16px 16px",
          borderRadius: "15px",
          minHeight: "100vh",

          gap: "12px",
          // minHeight: "calc(100vh - 80px)",
        }}
      >
        {/* <div className="d-flex mt-4 justify-content-center text-center">
          <h4
            className="text-center"
            style={{
              color: HEADER_COLOR,
            }}
          >
            Knowledge
          </h4>
        </div> */}

        <div className="row p-0 w-100 mx-auto">
          <div className="col-12 p-0">
            <div
              className="row w-100 mx-auto align-items-center justify-content-center"
              style={{
                gap: "8px",
              }}
            >
              <div className="col p-0">
                <button
                  onClick={() => {
                    setKnowledgeVal("Glossary");
                  }}
                  className="btn w-100 service-alt-btn"
                  style={{
                    padding: "9px 0",
                    border: `1px solid ${PRIMARY_COLOR}`,
                    borderRadius: "15px",
                    lineHeight: "1",
                    backgroundColor:
                      knowledgeVal === "Glossary" ? TERTIARY_COLOR : "",
                  }}
                >
                  <div
                    className=""
                    style={{
                      fontSize: "13.5px",
                      color: PRIMARY_COLOR,
                      fontWeight: "400",
                    }}
                  >
                    Glossary
                  </div>
                </button>
              </div>

              <div className="col p-0">
                <button
                  onClick={() => {
                    setKnowledgeVal("FAQs");
                  }}
                  className="btn w-100 service-alt-btn"
                  style={{
                    padding: "9px 0",
                    border: `1px solid ${PRIMARY_COLOR}`,
                    borderRadius: "15px",
                    lineHeight: "1",
                    backgroundColor:
                      knowledgeVal === "FAQs" ? TERTIARY_COLOR : "",
                  }}
                >
                  <div
                    className=""
                    style={{
                      fontSize: "13.5px",
                      color: PRIMARY_COLOR,
                      fontWeight: "400",
                    }}
                  >
                    FAQs
                  </div>
                </button>
              </div>
            </div>

            {knowledgeVal === "Glossary" && (
              <div>
                <hr />
                <div
                  className="row w-100 mx-auto align-items-center flex-nowrap"
                  ref={scrollLettersRef}
                  style={{
                    overflowX: "scroll",
                    scrollBehavior: "smooth",
                    scrollbarWidth: "none",
                    justifyContent: screenWidth >= 700 ? "center" : "start",
                  }}
                >
                  {letters &&
                    letters?.length > 0 &&
                    letters.map((letter, index) => {
                      return (
                        <button
                          key={index}
                          onClick={() => {
                            setSelectedGlossary(letter);
                          }}
                          className="btn service-btn-alt p-0 d-flex align-items-center justify-content-center"
                          style={{
                            // lineHeight: '0.95',
                            // padding: '4.25px 5.5px',
                            // fontSize: screenWidth >= 576 ? '12.25px' : '8.5px',
                            fontSize: screenWidth >= 576 ? "12px" : "8.5px",
                            backgroundColor:
                              selectedGlossary === letter ? TERTIARY_COLOR : "",
                            color: PRIMARY_COLOR,
                            border: `1px solid ${SECONDARY_COLOR}`,
                            borderRadius: "2.25px",
                            width: screenWidth >= 576 ? "24px" : "20px",
                            height: screenWidth >= 576 ? "23px" : "19px",
                            // width: screenWidth >= 576 ? '24px' : 'unset'
                          }}
                        >
                          {letter}
                        </button>
                      );
                    })}
                </div>
                <hr />
                {screenWidth <= 699 && (
                  <div
                    className="position-absolute d-flex align-items-center justify-content-center"
                    style={{
                      top: "0",
                      right: "-12px",
                      height: "100%",
                      zIndex: "10",
                      paddingTop: "3.5px",
                    }}
                  >
                    <SlArrowRight
                      style={{
                        color: TERTIARY_COLOR,
                        height: "14px",
                        width: "14px",
                      }}
                      onClick={() => handleScrollRight()}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {knowledgeVal === "Glossary" ? (
            <div>
              <div
                className="text-start"
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: PRIMARY_COLOR,
                }}
              >
                {selectedGlossary}
              </div>

              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-start flex-nowrap"
                style={{
                  gap: "20px",
                  // maxHeight: "calc(100vh - 275px)",
                  maxHeight: "75vh",
                  overflowY: "scroll",
                  scrollBehaviour: "smooth",
                  scrollbarWidth: "none",
                }}
              >
                {glossaryData?.find((item) => item?.label === selectedGlossary)
                  ?.content?.length > 0 ? (
                  glossaryData
                    ?.find((item) => item?.label === selectedGlossary)
                    ?.content?.map((term, index) => {
                      return (
                        <div
                          className="p-0 text-start"
                          style={{
                            fontSize: "12.5px",
                            fontWeight: "600",
                            color: TEXT_COLOR,
                            // textAlign: 'start'
                          }}
                          key={index}
                        >
                          <div
                            className=""
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            {term.title}
                          </div>

                          <div
                            className=""
                            style={{
                              fontWeight: "400",
                              lineHeight: "1.4",
                            }}
                          >
                            {term.definition}
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div className="text-center">No data found!</div>
                )}
              </div>
            </div>
          ) : (
            <div className="col-12 p-0 mt-3">
              <hr />
              <div
                className="row w-100 mx-auto flex-column align-items-center justify-content-start flex-nowrap"
                style={{
                  gap: "20px",
                  // maxHeight: "calc(100vh - 275px)",
                  maxHeight: "80vh",
                  overflowY: "scroll",
                  scrollBehaviour: "smooth",
                  scrollbarWidth: "none",
                }}
              >
                {FAQsArr?.length > 0 ? (
                  FAQsArr?.map((term, index) => {
                    return (
                      <div className="col-12 p-0" key={index}>
                        <div
                          className="text-start"
                          style={{
                            fontSize: "12.5px",
                            fontWeight: "600",
                            color: TEXT_COLOR,
                            // textAlign: 'start'
                          }}
                        >
                          <div
                            className=""
                            style={{
                              fontSize: "13px",
                            }}
                          >
                            {term.title}
                          </div>

                          <div
                            className=""
                            style={{
                              fontWeight: "400",
                              lineHeight: "1.4",
                            }}
                          >
                            {term.definition}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center">No data found!</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeScreen;
